<template>
  <div class="dashboard">
    <PageTitle main="Dashboard da base de conhecimento" />
    <div class="row-card">
      <CardIndicador icon="fa fa-eye" title="Total de visualizações" :value="indicators.totalViews" />
      <CardIndicador icon="fa fa-star" title="Média de avaliações" :value="indicators.averageRatings" />
      <CardIndicador icon="fa fa-star-o" title="Avaliações este mês" :value="indicators.totalRatingsThisMonth" />
      <CardIndicador icon="fa fa-comments-o" title="Total de comentários" :value="indicators.totalComments" />
    </div>
    <div class="row-card">
      <CardIndicador icon="fa fa-comments" title="Comentários este mês" :value="indicators.totalCommentsThisMonth" />
      <CardIndicador icon="fa fa-file-text-o" title="Artigos novos este mês" :value="indicators.totalArticlesThisMonth" />
      <CardIndicador icon="fa fa-pencil-square-o" title="Modificados este mês"
        :value="indicators.totalArticlesChangedThisMonth" />
      <CardIndicador icon="fa fa-file-text" title="Total de artigos" :value="stat.articles" />
    </div>
    <div class="chart-row">
      <BarChart :nameArticles="names" :viewsArticles="views" :title="'Artigos mais visualizados'"/>
    </div>
    <div class="chart-row">
      <BarChart :nameArticles="this.categoryNames" :viewsArticles="this.totalCategoryViews" :title="'Categorias mais visualizadas'"/>
    </div>
    <div class="chart-row">
      <BarChart :nameArticles="this.namesSubcategories" :viewsArticles="this.totalViewsSubcategories" :title="'Subcategorias mais visualizadas'"/>
    </div>
  </div>
</template>

<script>
import BarChart from './BarChart.vue';
import PageTitle from "../template/PageTitle.vue";
import Stat from "./Stat.vue";
import axios from "axios";
import { baseApiUrl } from "@/global";
import CardIndicador from "./Card.vue";
export default {
  name: "Dashboard",
  components: { PageTitle, Stat, CardIndicador, BarChart },
  props: ["names", "views"],
  data: function () {
    return {
      stat: {},
      indicators: {},
      dashboardSubcategory: {},
      
      namesSubcategories: [],
      totalViewsSubcategories: [],

      categoryNames: [],
      totalCategoryViews: [],
    };
  },
  methods: {
    getStats() {
      axios
        .get(`${baseApiUrl}/api/publico/home/dashboard`)
        .then((res) => (this.stat = res.data));
    },
    getIdicators() {
      axios.get(`${baseApiUrl}/api/artigos/dashboard-administrativo`).then((res) => {
        this.indicators = res.data;
      });
    },
    getDashboardSubcategory() {
      axios.get(`${baseApiUrl}/api/publico/home/subcategorias-mais-acessadas`).then((res) => {
        this.dashboardSubcategory = res.data;
        this.filterNamesAndViews();
      });
    },
    getDashboardCategory() {
      axios.get(`${baseApiUrl}/api/publico/home/categorias-mais-acessadas`).then((res) => {
        this.dashboardCategory = res.data;
        this.filterNamesAndViewsCategory();
      });
    },
    filterNamesAndViews() {
      this.namesSubcategories = this.dashboardSubcategory.map((data) => data.nome);
      this.totalViewsSubcategories = this.dashboardSubcategory.map((data) => data.visualizacoes);
    },

    filterNamesAndViewsCategory() {
      this.categoryNames = this.dashboardCategory.map((data) => data.nome);
      this.totalCategoryViews = this.dashboardCategory.map((data) => data.visualizacoes);
    },
  },
  mounted() {
    this.getStats();
    this.getIdicators();
    this.getDashboardSubcategory();
    this.getDashboardCategory();
  },
};
</script>

<style>
.row-card {
  width: 100.9%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.chart-row {
  background-color: #fcfcfc;
  padding: 30px;
  padding-top: 15px;
  padding-left: 0px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 99.5%;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 880px) {
  .row-card {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .row-card {
    grid-template-columns: 1fr;
  }
}
</style>